import React from 'react';
import I18n from 'app/i18n';
import {localDateFromISO} from 'app/utils';
import {showPopup} from 'app/utils/modals/ModalsService';
import {startBattlenetAuthFlow} from 'app/utils/battlenetAuth';
import BattlenetDisconnectPopup from './BattlenetDisconnectPopup';

interface Props {
    battlenetId: string | null
    battletag: string | null
    battlenetLinkedAt: string | null
    registeredViaBattlenet?: boolean
}

const handleConnect = (): void => startBattlenetAuthFlow();

const handleDisconnect = (): void => {
    showPopup('battlenet-disconnect', props => <BattlenetDisconnectPopup popupId={props.popupId}/>);
};

const BattlenetInformation = ({
    battlenetId, battletag, battlenetLinkedAt, registeredViaBattlenet
}: Props): React.ReactElement => {
    const isLinked = Boolean(battlenetId);

    if (!isLinked && registeredViaBattlenet) {
        return null;
    }

    return <div className="profile__info-user-wrap">
        <dl className="profile__info-user">
            <dt>{I18n.t('battlenet.labels.battlenet')}</dt>
            <dd>{isLinked && (battletag || battlenetId)}</dd>
            {isLinked && battlenetLinkedAt && <dd className="profile__steam-linked-at">
                {I18n.t('battlenet.labels.linked_at')}: {localDateFromISO(battlenetLinkedAt)}
            </dd>}
        </dl>
        <div className="profile__btn">
            {isLinked
                ? <button className="btn" type="button" onClick={handleDisconnect}>
                    {I18n.t('battlenet.labels.disconnect')}
                </button>
                : <button className="btn" type="button" onClick={handleConnect}>
                    {I18n.t('battlenet.labels.connect')}
                </button>}
        </div>
    </div>;
};

export default BattlenetInformation;
